import ResponseHelper from './response-helper';

/**
 * Lib that manages communication with Vizzto server related to gamifications.
 * Returns with `code = 0` are considered sucessfull.
 */

/**
 * @typedef FieldErrorResponse All methods can return a failed promise with field validation errors following this structure.
 * @type {Object}
 * @property {Number} code Field validation error code (400)
 * @property {String} message Global error message (like: "Some fields are invalid.").
 * @property {Object} data Holds the errors. Each property is related to a field error. Property's key must be the field name. Property's value must be the error message.
 * @example { code: 400, message: "Request is invalid.", data: { user: "User cannot have more than 3 chars.", password: "Password doesn't have special char." } }
 */
export default (axios) => ({
  /**
   * Notifies server when user download an attachment
   * @param {String} userToken User token as informed by server on authentication.
   * @param {Object} selectedAttachment Text filled by user in search form.
   * @returns {Promise}
   */
  downloadAttachment(userToken, selectedAttachment) {
    return axios({
      method: 'post',
      url: 'gamifications/download',
      headers: {
        utoken: userToken
      },
      data: selectedAttachment
    }).then(() => {
      return Promise.resolve({
        code: 0,
        message: 'OK',
        data: {}
      }).catch((error) => {
        return Promise.reject(ResponseHelper.getErrorResponse(error));
      });
    });
  }
});
